var _rect, _g, _path, _path2, _path3, _path4, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKenya(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_306_1295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_306_1295)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V8H32V0H0Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16V24H32V16H0Z",
    fill: "#4D8B1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7H-1V8V16V17H0H32H33V16V8V7H32H0Z",
    fill: "#E31C1C",
    stroke: "#F5FBFF",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0195 3.92856C19.2098 3.53836 19.7215 3.11227 20.5545 2.65028C20.5831 2.63441 20.6177 2.6335 20.6471 2.64785C20.6969 2.67213 20.7175 2.73217 20.693 2.78183L12.0617 20.4786L11.6123 20.2594L19.2207 4.65984C18.8762 4.60372 18.8091 4.35996 19.0195 3.92856Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9709 3.92856C13.1813 4.35996 13.1143 4.60372 12.7697 4.65984L20.3781 20.2594L19.9287 20.4786L11.2975 2.78183C11.2729 2.73217 11.2936 2.67213 11.3434 2.64785C11.3728 2.6335 11.4074 2.63441 11.436 2.65028C12.269 3.11227 12.7806 3.53836 12.9709 3.92856Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20C16.9967 20 21 16.4183 21 12C21 7.58172 16.9967 4 16 4C15.0033 4 11 7.58172 11 12C11 16.4183 15.0033 20 16 20Z",
    fill: "#E31C1C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_306_1295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 4,
    width: 10,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20C16.9967 20 21 16.4183 21 12C21 7.58172 16.9967 4 16 4C15.0033 4 11 7.58172 11 12C11 16.4183 15.0033 20 16 20Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_306_1295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 19C10.366 19 13.5 15.866 13.5 12C13.5 8.13401 10.366 5 6.5 5C2.63401 5 -0.5 8.13401 -0.5 12C-0.5 15.866 2.63401 19 6.5 19Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 19C29.366 19 32.5 15.866 32.5 12C32.5 8.13401 29.366 5 25.5 5C21.634 5 18.5 8.13401 18.5 12C18.5 15.866 21.634 19 25.5 19Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 10.9293C16.6564 10.605 17 9.19259 17 7.49932C17 5.80605 16.6564 4.39363 16.2 4.06934V10.9293ZM15.7 10.8391C15.2943 10.3931 15 9.0665 15 7.49932C15 5.93215 15.2943 4.60555 15.7 4.15955V10.8391ZM15.7 13.1596V19.8391C15.2943 19.3931 15 18.0665 15 16.4993C15 14.9321 15.2943 13.6055 15.7 13.1596ZM16.2 19.9293V13.0693C16.6564 13.3936 17 14.8061 17 16.4993C17 18.1926 16.6564 19.605 16.2 19.9293Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11Z",
    fill: "#F5FBFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/kenya.838128895321715833bb62f9a792bb98.svg";
export { ForwardRef as ReactComponent };